<template>
  <footer class="footer" data-anim="footer">
    <ul class="c-container c-container--big">
      <li class="footer__item">
        <p class="item__title">Contatti</p>
        <ul class="footer__sub-item">
          <li>P.Iva 00597210988</li>
          <li>C.F. 01034930170</li>
        </ul>
      </li>
      <li class="footer__item">
        <p class="item__title">Legal</p>
        <ul class="footer__sub-item">
          <li>
            <a href="#" target="_blank" rel="noopener">Privacy Policy</a>
          </li>
          <li>
            <a href="#" target="_blank" rel="noopener">Terms & Conditions</a>
          </li>
          <li>
            <a href="#" target="_blank" rel="noopener">Cookies</a>
          </li>
        </ul>
      </li>
      <li class="footer__item">
        <p class="item__title">Site Map</p>
        <ul class="footer__sub-item">
          <li
            v-for="(item, i) in navigator[currentLang]"
            :key="i"
          >
            <router-link :to="item.url">
              {{ item.voice }}
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </footer>
</template>

<script>
import { mapState } from 'vuex';
import navigator from '@/assets/data/navigator.json';

export default {
  name: 'AppFooter',

  data() {
    return {
      navigator,
    };
  },

  computed: {
    ...mapState(['currentLang']),
  },
};
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  padding: 80px 40px 60px;

  background-color: $color-black;

  .item__title {
    display: inline-block;
    color: $color-white;
  }

  .footer__item {
    position: relative;
    padding: 20px 0;
    margin-bottom: 20px;

    display: grid;
    grid-template-columns: 100px auto 1rem;

    &::before {
      content: '';

      position: absolute;
      bottom: 0;
      left: 0;
      width: calc(100% - 80px);
      height: 1px;

      background-color: $color-text;
    }
  }

  .footer__sub-item {
    display: inline-block;
    margin-left: 40px;

    li {
      display: inline-block;
      margin-right: 20px;
    }
  }
}
</style>
